import React from 'react'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

export default function Conditions(props) {
    return (
        <>
            <SEOTAG page="Conditions" />
            <Layout props={props}>
                <div className="px-5 py-4 stctPgWrpr">
                    {/* <h2>About Us</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global.storeDetails.terms_condition,
                        }}
                    ></span>
                </div>
            </Layout>
        </>
    )
}
